import { render, staticRenderFns } from "./tipsDialog.vue?vue&type=template&id=233aa186&scoped=true&"
import script from "./tipsDialog.vue?vue&type=script&lang=js&"
export * from "./tipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./tipsDialog.vue?vue&type=style&index=0&id=233aa186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233aa186",
  null
  
)

export default component.exports